import React from 'react';

import DraftManualCRQProvider from './context';
import DraftManualCRQList from './List';

const DraftManualCRQ: React.FC = () => {
  return (
    <DraftManualCRQProvider>
      <DraftManualCRQList />
    </DraftManualCRQProvider>
  );
};

export default DraftManualCRQ;
